import { useContext } from 'react';
import HeightContext from '../../context/HeightContext';

const useHeightContext = () => {
  const context = useContext(HeightContext);
  return context;
};

export default useHeightContext;
